// extracted by mini-css-extract-plugin
export default {"thirdPartySessionTimeoutPopupModal":"third-party-session-timeout_thirdPartySessionTimeoutPopupModal__TT5E6"};